import { FormControl, ValidatorFn } from '@angular/forms';
import { IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { CarouselItemControls } from './CarouselItemFormBuilder';

import { IFormBuilder } from '../IFormBuilder';

import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';

import { FaqItemControls } from './FaqItemFormBuilder';
import { ThemeData } from '../../theme-data.model';
import { ThemeDataFormGroup } from '../ThemeDataFormGroup';

interface IThemeDataFormBuilder extends IFormBuilder<ThemeDataControls> {
  init(themeData: ThemeData): IThemeDataFormBuilder;

  build(): IGenericBaryFormGroup<ThemeDataControls>;
}

export type ThemeDataControls = {
  carouselItems: IGenericBaryFormGroup<CarouselItemControls>[];
  faqs: IGenericBaryFormGroup<FaqItemControls>[];
  footerTransporterPhoneNumber: FormControl;
  footerTransporterAddress: FormControl;
  footerTransporterZipcode: FormControl;
  footerTransporterCity: FormControl;
  footerContactButtonAction: FormControl;
  footerTransporterDescription: FormControl;
  footerTransporterWebsite: FormControl;
  footerTransporterGroup: FormControl;
  mainJumbotronTitle: FormControl;
  mainJumbotronSubtitle: FormControl;
  mainJumbotronImage: FormControl;
  mainJumbotronContent: FormControl;
  mainSplashMessage: FormControl;
  splashLogo: FormControl;
  splashLogoPreview: FormControl;
  mainLogo: FormControl;
  mainLogoPreview: FormControl;
  disconnectedLogo: FormControl;
  disconnectedLogoPreview: FormControl;
};

export class ThemeDataFormBuilder implements IThemeDataFormBuilder {
  private formName = 'themeDataForm';
  private controls!: ThemeDataControls;
  private validators?: ValidatorFn[];

  constructor(private bcf: BaryFormFactoryService) {}

  init(themeData?: ThemeData): ThemeDataFormBuilder {
    this.controls = this.bcf.makeThemeDataControls(themeData);
    this.addCarouselItems(themeData);
    this.addFaqItems(themeData);
    return this;
  }

  private addCarouselItems(themeData?: ThemeData): void {
    if (themeData) {
      // ajoute autant de carouselItemControls que d'item présent.
      themeData?.carouselItems.forEach(it => {
        const carouselItem = this.bcf.makeCarouselItemForm(it);
        this.controls.carouselItems.push(carouselItem);
      });
    }
  }

  private addFaqItems(themeData?: ThemeData): void {
    if (themeData) {
      // ajoute autant de faqItemControls que d'item présent.
      themeData.faqs.forEach(item => {
        const faqItem = this.bcf.makeFaqItemForm(item);
        this.controls.faqs.push(faqItem);
      });
    }
  }

  build(): ThemeDataFormGroup {
    return new ThemeDataFormGroup(this.formName, this.controls, this.validators);
  }
}
